export { TimeSlotOptionHOC } from './TimeSlotOptionHOC';
